import SortableSelect from "@/Components/Select/SortableSelect";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { arrayMove } from "react-sortable-hoc";
import { allergenen } from "../../shared/utils/helpers";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";

interface MenuFastAllergenProps extends ModalProps {}

const MenuFastAllergen = ({ onExit, ...props }: MenuFastAllergenProps) => {
  const { t } = useTranslation();
  const [selectedList, setSelectedList] = useState([]);
  const { productPatch } = useCategoryHook();
  const [{ parentId }] = useModalMeta();
  const setModal = useSetModal();

  const handleSubmit = (e) => {
    productPatch.mutateAsync(
      {
        data: {
          allergen: selectedList.map((allergen) => allergen.id),
          method: e.target.id,
        },
        categoryId: parentId,
        type: "allergens",
      },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal {...props} onExit={onExit}>
      <ModalTitle>{t("addAllergenCategory")}</ModalTitle>

      <div className="mt-4 flex flex-col gap-12">
        <SortableSelect
          key={Date.now()}
          onSortEnd={({ oldIndex, newIndex }) => {
            const newList = arrayMove(selectedList, oldIndex, newIndex);
            setSelectedList(newList);
          }}
          menuPortalTarget={document.getElementById("root")}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
          }}
          isMulti
          label={t("allergies")}
          name="allergies"
          placeholder={`${t("allergies")}....`}
          getOptionLabel={(option) => t(option.translationKey)}
          getOptionValue={(option) => option.id}
          value={selectedList}
          onChange={(v) => setSelectedList(v)}
          options={allergenen}
          optionLabel
        ></SortableSelect>
        <div className="flex gap-4">
          <Button
            isDisabled={Boolean(selectedList.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            variant={
              Boolean(selectedList.length) !== false ? "danger" : "default"
            }
            id="remove"
            onClick={handleSubmit}
          >
            {t("menu.remove")}
          </Button>
          <Button
            isDisabled={Boolean(selectedList.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            id="add"
            onClick={handleSubmit}
          >
            {t("menu.add")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuFastAllergen;
